import Monitor from "./libs/common/Monitor";
import Vue from "vue";

const __DEV__ = process.env.NODE_ENV === "local";

let projectCode = 'idt-bayer-dnc';

try {
  const projectType = window.location.pathname.split('/')[1]
  switch (projectType) {
    case 'display':
      projectCode = 'idt-bayer-display'
      break
    case 'conference':
      projectCode = 'idt-bayer-conference'
      break
  }
} catch (e) {
  console.log('通过pathname获取projectCode失败')
}

Monitor.init({
  logUpload: {
    projectCode: projectCode,
    enable: true,
    environment: __DEV__ ? "UAT" : "PROD",
    protocol: __DEV__ ? "http" : "https",
    intervalCollect: {
      enable: !__DEV__,
      collectTime: 60,
    },
  },
  logRecord: {
    dbName: "Idt-Monitor-Bayer-DB",
  },
  errorCatch: {
    enable: true,
    useLog: true,
    directUpload: false,
    debug: false,
  },
});

window.Monitor = Monitor;

Vue.config.errorHandler = (error, vm, info) =>
  Monitor.errorCatch.vueErrorHandler(error, vm, info);

Vue.prototype.$throw = (error, vm) =>
  Monitor.errorCatch.tryCatchHandler(error, vm, "try..catch");
